export const FETCH_MESSAGES_LIST = 'FETCH_MESSAGES_LIST';
export const FETCH_MESSAGES_LIST_SUCCESS = 'FETCH_MESSAGES_LIST_SUCCESS';
export const FETCH_MESSAGES_LIST_FAILURE = 'FETCH_MESSAGES_LIST_FAILURE';

export const FETCH_SINGLE_MESSAGE = 'FETCH_SINGLE_MESSAGE';
export const FETCH_SINGLE_MESSAGE_SUCCESS = 'FETCH_SINGLE_MESSAGE_SUCCESS';
export const FETCH_SINGLE_MESSAGE_FAILURE = 'FETCH_SINGLE_MESSAGE_FAILURE';

export const CLEAR_SINGLE_MESSAGE = 'CLEAR_SINGLE_MESSAGE'